var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBank(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 45.11,
    height: 45.382,
    viewBox: "0 0 45.11 45.382",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9ae236"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8acd2e"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "bank",
    d: "M2426.5,10216.381c-.7,0-1.5-.346-1.5-1.075v-3.927a1.518,1.518,0,0,1,1.5-1.334h2.555v-1.719a1.459,1.459,0,0,1,1.325-1.447h3.238v-15.311h-1.52v-2.642h5.068v2.642h-1.014v15.311h1.014v2.639h-5.576c0,3.484.25,3.167-4.055,3.167v1.058h40.04v-1.058h-3.048a1.507,1.507,0,0,1-1.512-1.306v-1.861h-5.576v-2.639h1.013v-15.311h-1.013v-2.642h5.068v2.642h-1.52v15.311c4.792,0,4.561-.555,4.561,3.166h3.248a1.348,1.348,0,0,1,1.314,1.334v3.927c0,.729-.615,1.075-1.314,1.075Zm22.323-6.863v-2.639h1.521v-15.311h-1.521v-2.642h5.068v2.642h-1.014v15.311h1.014v2.639Zm-8.109,0v-2.639h1.014v-15.311h-1.014v-2.642h5.068v2.642h-1.52v15.311h1.52v2.639Zm-14.54-22.592,20.731-15.645c1.014-.765-.1-1.186,22.217,15.689l-1.487,2.19-3.243-2.346H2430.9l-3.243,2.349Zm8.229-2.748h26.493l-13.247-10Zm11.38-2.642v-2.639h4.055v2.639Z",
    transform: "translate(-2424.999 -10170.999)",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBank);
export default __webpack_public_path__ + "static/media/bank.8967d2a7.svg";
export { ForwardRef as ReactComponent };